import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const widgetRef = useRef(null);

  // Close popup if user clicks outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (widgetRef.current && !widgetRef.current.contains(event.target)) {
        setIsChatOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <section className="footer_pading footer_dark_theme_video">
        {/* Background Video */}
        <div className="footer_video_wrapper">
          <video autoPlay loop muted playsInline className="footer_bg_video">
            <source src="/assets/video/footer-bg.mp4" type="video/mp4" />
          </video>
          <div className="footer_video_overlay"></div>
        </div>
        <div className="container">
          <div className="row g-lg-4 g-4 top-footer justify-content-between">
            <div className="col-lg-4 col-md-12 d-flex flex-column justify-content-between">
              <div>
                <Link className="navbar-brand text-white mb-3 d-inline-block" to="/">
                  <img src="assets/logo/Light@2x.png" alt="" className="header-logo" />
                </Link>
                <p className="heading-4 text-secondary mb-0">
                  A premium AI software and enterprise technology brand — building intelligent, scalable digital products for modern businesses.
                </p>
              </div>
              <div className="d-flex gap-3 align-items-center mt-4 pt-1">
                <a href="https://www.facebook.com/Genxmeta" target="_blank" rel="noopener noreferrer" title="Facebook">
                  <img
                    src="/assets/img/639b830a4cbdd20fd5f3a9a9/facebook.svg"
                    alt="Facebook"
                    className="image-3"
                  />
                </a>
                <a href="https://www.instagram.com/genxmetaofficial" target="_blank" rel="noopener noreferrer" title="Instagram">
                  <img
                    src="/assets/img/639b830a4cbdd20fd5f3a9a9/instagram.svg"
                    alt="Instagram"
                    className="image-3"
                  />
                </a>
                <a href="https://www.linkedin.com/in/genx-meta/" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                  <img
                    src="/assets/img/639b830a4cbdd20fd5f3a9a9/linkdin.svg"
                    alt="LinkedIn"
                    className="image-3"
                  />
                </a>
                <a href="https://wa.me/918860132221" target="_blank" rel="noopener noreferrer" title="WhatsApp" className="d-inline-flex align-items-center justify-content-center">
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="image-3">
                    <path fillRule="evenodd" clipRule="evenodd" d="M16 4C9.373 4 4 9.373 4 16C4 18.387 4.704 20.612 5.917 22.483L4.606 27.272L9.566 25.992C11.373 27.247 13.603 28 16 28C22.627 28 28 22.627 28 16C28 9.373 22.627 4 16 4ZM21.91 19.938C21.666 20.627 20.697 21.218 19.897 21.39C19.352 21.506 18.647 21.597 16.257 20.608C13.201 19.344 11.233 16.241 11.08 16.038C10.932 15.836 9.839 14.385 9.839 12.883C9.839 11.381 10.604 10.648 10.909 10.334C11.161 10.073 11.579 9.957 11.976 9.957C12.105 9.957 12.221 9.963 12.324 9.969C12.629 9.983 12.782 10.001 12.98 10.476C13.232 11.084 13.843 12.576 13.919 12.73C13.995 12.883 14.072 13.089 13.968 13.292C13.869 13.5 13.785 13.593 13.632 13.769C13.479 13.945 13.334 14.076 13.174 14.267C13.029 14.436 12.868 14.619 13.036 14.909C13.204 15.192 13.785 16.141 14.64 16.901C15.74 17.88 16.634 18.194 16.955 18.331C17.2 18.438 17.49 18.415 17.666 18.224C17.888 17.979 18.163 17.582 18.446 17.185C18.644 16.909 18.896 16.871 19.163 16.971C19.438 17.062 20.889 17.781 21.187 17.926C21.485 18.079 21.683 18.156 21.752 18.271C21.821 18.386 21.821 18.937 21.577 19.626L21.91 19.938Z" fill="#B1CBF0"/>
                  </svg>
                </a>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-6">
              <h6 className="font_22 mb-lg-4 mb-3 fw-bold">Company</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="/"
                    className="text-decoration-none text_grey font_14"
                  >
                    Home
                  </a>
                </li>
                <li className="mb-2">
                  <Link
                    to="/about"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    About Us
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/blockchain-consulting"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Consulting
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/contact"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Technology
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/contact"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-2 col-md-4 col-6">
              <h6 className="font_22 mb-lg-4 mb-3 fw-bold">Services</h6>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Custom Software
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    AI Solutions
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    Blockchain
                  </a>
                </li>
                <li className="mb-2">
                  <a
                    href="/"
                    className="mb-2 text-decoration-none text_grey font_14"
                  >
                    SaaS Products
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-4 col-12">
              <h6 className="font_22 mb-lg-4 mb-3 fw-bold">Our Offices</h6>
              <div className="d-flex flex-column gap-3">
                <div>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <span className="fw-bold text-white font_14">Dubai Office</span>
                    <span className="badge rounded-pill px-2 py-0" style={{ background: "rgba(0, 210, 255, 0.15)", color: "#00d2ff", border: "1px solid rgba(0, 210, 255, 0.3)", fontSize: "11px" }}>UAE</span>
                  </div>
                  <p className="font_12 text_grey mb-1 lh-sm">
                    Al Shohada Road, Al Hamra Industrial Zone - FZ,<br />
                    Ras Al Khaimah, United Arab Emirates
                  </p>
                  <p className="font_12 text_grey mb-1">
                    Phone:{" "}
                    <a href="tel:+971501855369" className="text-decoration-none text-white fw-semibold">
                      +971 50 185 5369
                    </a>
                  </p>
                  <p className="font_12 text_grey mb-0">
                    Email:{" "}
                    <a href="mailto:us@genxmeta.com" className="text-decoration-none text-white fw-semibold">
                      us@genxmeta.com
                    </a>
                  </p>
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2 mb-1">
                    <span className="fw-bold text-white font_14">India Office</span>
                    <span className="badge rounded-pill px-2 py-0" style={{ background: "rgba(0, 210, 255, 0.15)", color: "#00d2ff", border: "1px solid rgba(0, 210, 255, 0.3)", fontSize: "11px" }}>India</span>
                  </div>
                  <p className="font_12 text_grey mb-1 lh-sm">
                    Genxmeta ABC Tower, Assotech Business Cressterra,<br />
                    Sector 135, Noida - 201305
                  </p>
                  <p className="font_12 text_grey mb-1">
                    Phone:{" "}
                    <a href="tel:+918860132221" className="text-decoration-none text-white fw-semibold">
                      +91 88601 32221
                    </a>
                  </p>
                  <p className="font_12 text_grey mb-0">
                    Email:{" "}
                    <a href="mailto:us@genxmeta.com" className="text-decoration-none text-white fw-semibold">
                      us@genxmeta.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 mt-0 lower_footer">
            <div className="d-flex flex-wrap align-items-center gap-4 my-4">
              <div className="font_12 text-secondary">© genxmeta 2024</div>
              <div className="d-flex align-items-center gap-4">
                <a
                  href="/"
                  className="text-decoration-none font_12 text-secondary"
                >
                  Privacy policy
                </a>
                <span className="text-muted">|</span>
                <a
                  href="/"
                  className="text-decoration-none font_12 text-secondary"
                >
                  Terms of Use
                </a>
                <span className="text-muted">|</span>
                <a
                  href="/"
                  className="text-decoration-none font_12 text-secondary"
                >
                  Cookies
                </a>
              </div>
            </div>
          </div>

        </div>

      </section>

      {/* Floating Multi-Number WhatsApp Support Widget */}
      <div className="whatsapp-widget-wrapper" ref={widgetRef}>
        {/* Popup Drawer / Modal */}
        {isChatOpen && (
          <div className="wa-chat-popup">
            <div className="wa-popup-header">
              <div>
                <div className="wa-popup-header-title">GenXMeta Support</div>
                <div className="wa-popup-status">
                  <span className="wa-status-dot"></span>
                  Online • Typically replies instantly
                </div>
              </div>
              <button
                type="button"
                className="wa-popup-close-btn"
                onClick={() => setIsChatOpen(false)}
                title="Close"
              >
                ✕
              </button>
            </div>

            <div className="wa-popup-body">
              <div className="wa-popup-bubble">
                👋 Hello! Select your preferred office to chat directly with our technology consultants:
              </div>

              {/* India WhatsApp Option */}
              <a
                href="https://wa.me/918860132221?text=Hello%20Genxmeta%20Team%2C%20I%20would%20like%20to%20inquire%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
                className="wa-option-card"
              >
                <div className="wa-option-card-left">
                  <span className="wa-option-flag" role="img" aria-label="India">🇮🇳</span>
                  <div>
                    <div className="wa-option-title">India Office</div>
                    <div className="wa-option-num">+91 88601 32221</div>
                  </div>
                </div>
                <div className="wa-option-action">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24M8.53 7.33c-.16 0-.42.06-.64.3-.22.25-.85.83-.85 2.02 0 1.19.87 2.34.99 2.5.12.16 1.7 2.6 4.12 3.65.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.47-.29s-1.44-.71-1.66-.79c-.22-.08-.39-.12-.55.12-.16.25-.64.79-.78.96-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.55-1.33-.76-1.82-.2-.48-.41-.41-.56-.42-.14-.01-.31-.01-.47-.01"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </a>

              {/* Dubai WhatsApp Option */}
              <a
                href="https://wa.me/971501855369?text=Hello%20Genxmeta%20Team%2C%20I%20would%20like%20to%20inquire%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
                className="wa-option-card"
              >
                <div className="wa-option-card-left">
                  <span className="wa-option-flag" role="img" aria-label="UAE">🇦🇪</span>
                  <div>
                    <div className="wa-option-title">Dubai Office</div>
                    <div className="wa-option-num">+971 50 185 5369</div>
                  </div>
                </div>
                <div className="wa-option-action">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24M8.53 7.33c-.16 0-.42.06-.64.3-.22.25-.85.83-.85 2.02 0 1.19.87 2.34.99 2.5.12.16 1.7 2.6 4.12 3.65.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.47-.29s-1.44-.71-1.66-.79c-.22-.08-.39-.12-.55.12-.16.25-.64.79-.78.96-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.55-1.33-.76-1.82-.2-.48-.41-.41-.56-.42-.14-.01-.31-.01-.47-.01"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </a>
            </div>
          </div>
        )}

        {/* Trigger Button */}
        <button
          type="button"
          className="whatsapp-float-btn"
          onClick={() => setIsChatOpen(!isChatOpen)}
          title="Support Chat on WhatsApp"
          aria-label="Support Chat on WhatsApp"
        >
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2m.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24M8.53 7.33c-.16 0-.42.06-.64.3-.22.25-.85.83-.85 2.02 0 1.19.87 2.34.99 2.5.12.16 1.7 2.6 4.12 3.65.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.47-.29s-1.44-.71-1.66-.79c-.22-.08-.39-.12-.55.12-.16.25-.64.79-.78.96-.14.16-.29.18-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.44-.06-.12-.55-1.33-.76-1.82-.2-.48-.41-.41-.56-.42-.14-.01-.31-.01-.47-.01"
              fill="#ffffff"
            />
          </svg>
        </button>
      </div>
    </>
  );
}
